import React, { useState } from "react";
import NaviBar from "../../../Component/Eng_Nav/Navbar";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Badge from "react-bootstrap/Badge";
import Pagination from "react-bootstrap/Pagination";

import './Award.css'
import data from './data.json'; 

function Award() {
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(6);
    const [activeFilter, setActiveFilter] = useState("all");

    const filteredData = data.data.filter(item => activeFilter === "all" || item.type === activeFilter);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(filteredData.length / itemsPerPage); i++) {
        pageNumbers.push(i);
    }

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleFilterChange = (filterType) => {
        setActiveFilter(filterType);
        setCurrentPage(1); // Reset to the first page when changing the filter
    };

    return (
        <>
            <NaviBar />
            <div className={'award-bg'}>
                
                <Container style={{marginTop:"5%"}}>
                    <Row className="justify-content-center">
                        <Col md={12}>
                            <div className="filter-buttons">
                                <Badge
                                    className={"award-badges " + (activeFilter === "all" ? "bg-active" : "bg-white")}
                                    onClick={() => handleFilterChange("all")}
                                >
                                    All
                                </Badge>{" "}
                                <Badge
                                    className={"award-badges " + (activeFilter === "certificate" ? "bg-active" : "bg-white")}
                                    onClick={() => handleFilterChange("certificate")}
                                >
                                    Certificate
                                </Badge>{" "}
                                <Badge
                                    className={"award-badges " + (activeFilter === "award" ? "bg-active" : "bg-white")}
                                    onClick={() => handleFilterChange("award")}
                                >
                                    Award
                                </Badge>{" "}
                            </div>
                        </Col>
                    </Row>
                    <Row className="justify-content-center">
                        {currentItems.map((item, index) => (
                            <Col key={index} md={6} xs={12}>
                                <div className="image-container">
                                    <img
                                        src={item.src}
                                        alt={`Image ${index + 1}`}
                                        className="award-image"
                                    />
                                    <div className="image-overlay" style={{backgroundColor: item.color, color:item.fontColor, width:"100%"}}>
                                        <div className="overlay-text" style={{marginTop:"30%"}}>{item.name}</div>
                                        <div className="overlay-text" style={{fontSize:"1rem"}}>{item.date}</div>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                    <Row className="justify-content-center">
                        <Col md={12}>
                            <div className="d-flex justify-content-center mt-3">
                                <Pagination>
                                    {pageNumbers.map((number) => (
                                        <Pagination.Item
                                            key={number}
                                            active={number === currentPage}
                                            onClick={() => handlePageChange(number)}
                                        >
                                            {number}
                                        </Pagination.Item>
                                    ))}
                                </Pagination>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default Award;
